import Head from 'next/head'
import Layout, { Breadcrumb } from 'components/layout'
import { Container } from 'components/ui'
import s from './quem-somos.module.css'

export default function SouCorretor() {
  const crums = [
    {
      label: 'Institucional',
    },
  ]
  return (
    <Layout>
      <Head>
        <title>Quem somos</title>
      </Head>
      <Breadcrumb crumbs={crums} />
      <Container className={s.root}>
        <h1 className={s.title}>Quem Somos</h1>

        <p>
          A Fazendinha em Casa aproxima quem produz de quem consome, num modelo colaborativo do produtor à mesa,
          resgatando o prazer da boa comida, da comida de verdade.
        </p>
        <p>
          Acreditamos que a forma como nos alimentamos tem profunda influência no mundo a nossa volta: seja na paisagem,
          na biodiversidade da terra, na economia local ou na nossa cultura e tradições.
        </p>
        <p>
          Por isso, cultivar um mundo melhor, valorizando o pequeno produtor, a produção local de alimentos, a
          diversidade, as culturas regionais, o consumo consciente e sustentável, é o que nos move diariamente.
        </p>
        <p>Nossas relações e atividades são regidas pelos seguintes valores:</p>
        <p>
          <strong>Terra</strong> (o campo, o alimento)
          <br />
          <strong>As pessoas</strong> (produtor familiar, o consumidor)
          <br />
          <strong>Sustentabilidade</strong> (vida, bem-estar, saúde)
          <br />
          <strong>Regional, local</strong> (artesanal, cultura, diversidade)
          <br />
          <strong>Design</strong>&nbsp;(tecnologia, inovação, simplicidade)
        </p>
      </Container>
    </Layout>
  )
}
